import * as React from 'react';
import { childClassClosure, baseClassAnd, ClassableProps } from '@jcharlesworthuk/your-mum-core/dist/functions';

const baseClass = 'step-by-step';
const childClass = childClassClosure(baseClass);

type Props = ClassableProps & {
    img: string;
    title: string;
    children: JSX.Element[] | JSX.Element;
};

const Step: React.FunctionComponent<Props> = props => {
    return <div className={childClass('step')}>
        <img src={props.img} alt={props.title} className={childClass('image')} />
        <h3 className={childClass('title')}>{props.title}</h3>
        <p>{props.children}</p>
    </div>
}

export default Step;